"use client";
import { PopoverAnchor, PopoverPortal } from "@radix-ui/react-popover";
import { useMediaQuery } from "@uidotdev/usehooks";
import { ReactNode } from "react";

import { cn } from "@/lib/utils";

import { buttonVariants } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import Link from "next/link";

export const dropdownMenuButtonClass =
  "block bg-white w-full px-3 py-2 text-left cursor-pointer transition-colors hover:bg-accent";

export function DropdownDivider({ className }: { className?: string }) {
  return <div className={cn("w-full border-b", className)} />;
}

export function UserDropdownMenu(props: {
  tcgSlug?: string;
  username: string;
  children: ReactNode;
}) {
  const { tcgSlug, username, children } = props;

  const isDesktop = useMediaQuery("(min-width: 500px)");

  return isDesktop ? (
    <div className="relative group">
      <div
        className={cn(
          "hidden md:block",
          buttonVariants({ variant: "ghost" }),
          "cursor-default select-none"
        )}
      >
        {tcgSlug ? (
          <Link href={`/tcg/${tcgSlug}/player/${username}/profile`}>
            Hi, {username}!
          </Link>
        ) : (
          `Hi, ${username}!`
        )}
      </div>
      <div
        className={cn(
          "absolute right-0 w-[150px] z-10",
          "bg-white border rounded-sm shadow-md text-sm",
          "hidden opacity-0 transition-opacity duration-300",
          "group-hover:opacity-100 group-hover:block"
        )}
      >
        {children}
      </div>
    </div>
  ) : (
    <Popover>
      <PopoverTrigger>
        <div
          className={cn(
            "hidden md:block",
            buttonVariants({ variant: "ghost" }),
            "cursor-default select-none"
          )}
        >
          Hi, {username}!
        </div>
        <PopoverAnchor />
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent>{children}</PopoverContent>
      </PopoverPortal>
    </Popover>
  );
}
